import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import usersRequest from "../../request/usersRequest";
import BannerMessage from "../common/bannerMessage/bannerMessage";
import "./forgotPasswordConfirm.css";

const ConfirmForgotPassword = () => {
	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();

	const [email, setEmail] = useState("");
	const [code, setCode] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const [loading, setLoading] = useState(false);
	const [toast, setToast] = useState("");
	const [success, setSuccess] = useState(false);

	function isStrongPassword(password) {
		return (
			typeof password === "string" &&
			password.length >= 8 &&
			/[A-Z]/.test(password) &&
			/[0-9]/.test(password) &&
			/\./.test(password)
		);
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		setToast("");

		if (!email || !code || !password || !confirmPassword) {
			setToast(
				translations[language].confirmForgotPassword.toast.required
			);
			return;
		}

		if (!isStrongPassword(password)) {
			setToast(
				translations[language].confirmForgotPassword.toast.weakPassword
			);
			return;
		}

		if (password !== confirmPassword) {
			setToast(
				translations[language].confirmForgotPassword.toast.mismatch
			);
			return;
		}

		try {
			setLoading(true);

			await usersRequest.confirmForgotPassword({
				email,
				code,
				newPassword: password,
			});

			setSuccess(true);

			setTimeout(() => {
				navigate("/signin");
			}, 1500);
		} catch (err) {
			console.error(err);
			setToast(
				translations[language].confirmForgotPassword.toast.invalidCode
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container">
			<div className="sf-confirmfp-modal">
				<h2 className="sf-confirmfp-title">
					{translations[language].confirmForgotPassword.title}
				</h2>

				{success ? (
					<p className="sf-confirmfp-success">
						{translations[language].confirmForgotPassword.success}
					</p>
				) : (
					<form onSubmit={handleSubmit}>
						<p className="sf-confirmfp-subtitle">
							{translations[language].confirmForgotPassword.subtitle}
						</p>

						<input
							type="email"
							className="sf-confirmfp-input"
							placeholder={
								translations[language].confirmForgotPassword.email
							}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>

						<input
							type="text"
							className="sf-confirmfp-input"
							placeholder={
								translations[language].confirmForgotPassword.code
							}
							value={code}
							onChange={(e) => setCode(e.target.value)}
						/>

						<input
							type="password"
							className="sf-confirmfp-input"
							placeholder={
								translations[language].confirmForgotPassword.password
							}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>

						<input
							type="password"
							className="sf-confirmfp-input"
							placeholder={
								translations[language].confirmForgotPassword.confirmPassword
							}
							value={confirmPassword}
							onChange={(e) =>
								setConfirmPassword(e.target.value)
							}
						/>

						<button
							type="submit"
							className="sf-confirmfp-btn"
							disabled={loading}
						>
							{loading
								? translations[language].confirmForgotPassword.submitting
								: translations[language].confirmForgotPassword.submit}
						</button>
					</form>
				)}

				{toast && <BannerMessage text={toast} />}
			</div>
		</div>
	);
};

export default ConfirmForgotPassword;
